import React from 'react';
import { useThemeClassName } from '@fluentui/react-components';

/**
 * See https://github.com/microsoft/fluentui/issues/23626
 *
 * Without this, modals/notifications will fail to load our custom theme object.
 */
export function ApplyToBody() {
  const classes = useThemeClassName();

  React.useEffect(() => {
    const classList = classes.split(' ');
    document.body.classList.add(...classList);

    return () => document.body.classList.remove(...classList);
  }, [classes]);

  return null;
}
